import { render } from "./index.vue?vue&type=template&id=4ecf2e7c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4ecf2e7c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecf2e7c"]])

export default __exports__